import { cn } from 'src/shared/lib/utils';
import { ReactChildren } from 'src/shared/types/util.types';

type PageBodyProps = {
  excludeMaxWidth?: boolean;
  removePadding?: boolean;
  className?: string;
  allowScroll?: boolean; // New prop to control scrolling behavior
} & ReactChildren;

export default function PageBody({
  excludeMaxWidth = false,
  removePadding = false,
  children,
  className,
  allowScroll = true, // Default to allowing scroll for backward compatibility
}: PageBodyProps) {
  return (
    <div
      className={cn(
        'bg-muted flex flex-col',
        removePadding ? 'p-0' : 'p-5',
        allowScroll ? 'overflow-y-auto' : 'overflow-hidden',
        allowScroll && '!pb-10', // Use !important to override p-0 when needed
        className
      )}
      style={{
        gridArea: 'main',
        height: '100%',
        ...(allowScroll ? {} : { maxHeight: '100vh' }),
      }}
    >
      {excludeMaxWidth ? (
        <div className={cn('flex-1 flex flex-col', allowScroll ? '' : 'h-full max-h-full overflow-hidden')}>
          {children}
        </div>
      ) : (
        <div
          className={cn(
            'w-full max-w-body mx-auto flex flex-col',
            allowScroll ? '' : 'h-full max-h-full overflow-hidden',
            removePadding && 'p-0'
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
}
